import { StarIcon } from "@chakra-ui/icons";
import {
  Box,
  Image,
  Text,
  Tag,
  Spinner,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Flex,
  ModalBody,
  Input,
  useDisclosure,
  Textarea,
  useToast,
  ModalCloseButton,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
// import { BsCart2 } from "react-icons/bs";
import { Link } from "react-router-dom";
import { BASE_URL_FLORAHUB, BASE_URL_USER } from "../../../Redux/App/action";
import { useSelector } from "react-redux";
import close from "../../../assets/buttons/close.png";
const CorporateGifting = () => {
  const [data, setData] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [name, setName] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const toast = useToast();
  const { isLoading } = useSelector((store) => store.appReducer);
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const Loader = () => {
    return (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        background="rgba(0, 0, 0, 0.5)"
        zIndex="9999"
      >
        <Spinner size="xl" color="blue.500" thickness="5px" />
      </Box>
    );
  };
  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("mobileNo", PhoneNumber);
    formData.append("message", message);

    axios
      .post(`${BASE_URL_USER}/public-api/v1/contact-us`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        onClose();
        toast({
          title: "Sent Successfully",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
        setName("");
        setPhoneNumber("");
        setEmail("");
        setMessage("");
      })
      .catch((error) => {
        console.clear(`${error.message}`);
      });
  };

  const getCorporate = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_FLORAHUB}/inventory/api/v1/corporateGifting?page=0&size=100`,

        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        setData(response.data.payload.content);
      }
    } catch (error) {
      console.clear(error);
    }
  };
  useEffect(() => {
    getCorporate();
  }, []);
  if (isLoading) {
    return (
      <Box h={"100vh"}>
        <Loader />
      </Box>
    );
  }
  return (
    <>
      <Box
        w="full"
        alignItems="center"
        p={5}
        gap={5}
        display={"grid"}
        gridTemplateColumns={{
          md: "repeat(4,1fr)",
          base: "repeat(1,1fr)",
        }}
      >
        {data &&
          data.map((el, i) => (
            <Box
              bg="white"
              maxW="sm"
              borderWidth="1px"
              key={i}
              cursor={"pointer"}
              onClick={onOpen}
            >
              <Image src={el.imageUrl} alt={"imageAlt"} w={"100%"} h={220} />
              <Box p="2">
                <Text
                  mt="1"
                  fontWeight="semibold"
                  as="h4"
                  className="oswald-font"
                  lineHeight="tight"
                  noOfLines={1}
                >
                  {el.productName}
                </Text>

                <Box>₹{el.price}</Box>
                <Tag variant="solid" colorScheme="teal">
                  {el.productCode}
                </Tag>
              </Box>
            </Box>
          ))}
      </Box>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent
          borderRadius={0}
          w={{ md: "30%", base: "98%" }}
          textAlign={"left"}
        >
          <ModalCloseButton />
          <ModalHeader>
            <Flex
              alignItems={"center"}
              justifyContent={"space-between"}
              className="oswald-font"
            >
              SEND INQUIRY
            </Flex>
          </ModalHeader>
          <ModalBody pb={6} borderRadius={0}>
            <Flex alignItems={"center"} justifyContent={"center"} pr={5}>
              <Text
                w={"50%"}
                color={"#3E3E3E"}
                fontSize={{ md: 16, base: 10 }}
                fontWeight={"normal"}
                className="lato-font"
              >
                Name<span style={{ color: "#FC1A64" }}>*</span>{" "}
              </Text>
              <Input
                border={0}
                borderBottom={"1px solid gray"}
                type="text"
                onChange={(e) => {
                  const sanitizedValue = e.target.value.replace(
                    /[^a-zA-Z\s]/g,
                    "",
                  );
                  setName(sanitizedValue);
                }}
                ref={initialRef}
                name="name"
                value={name}
                borderRadius={0}
                mt={"-8%"}
                w={"70%"}
                focusBorderColor="transparent"
                _focusVisible={false}
              />
            </Flex>
            <Flex alignItems={"center"} justifyContent={"center"} pr={5} mt={4}>
              <Text
                w={"50%"}
                color={"#3E3E3E"}
                fontSize={{ md: 16, base: 10 }}
                fontWeight={"normal"}
                className="lato-font"
              >
                Mobile Number
                <span style={{ color: "#FC1A64" }}>*</span>{" "}
              </Text>
              <Input
                border={0}
                borderBottom={"1px solid gray"}
                type="number"
                name="PhoneNumber"
                value={PhoneNumber}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (inputValue.length <= 10) {
                    setPhoneNumber(inputValue);
                  }
                }}
                borderRadius={0}
                mt={"-8%"}
                maxLength={10}
                w={"70%"}
                focusBorderColor="transparent"
                _focusVisible={false}
              />
            </Flex>
            <Flex alignItems={"center"} justifyContent={"center"} pr={5} mt={4}>
              <Text
                w={"50%"}
                color={"#3E3E3E"}
                fontSize={{ md: 16, base: 10 }}
                fontWeight={"normal"}
                className="lato-font"
              >
                Email<span style={{ color: "#FC1A64" }}>*</span>{" "}
              </Text>
              <Input
                border={0}
                borderBottom={"1px solid gray"}
                type="email"
                name="email"
                value={email}
                onChange={(e) => {
                  const sanitizedValue = e.target.value.replace(
                    /[^a-zA-Z@.]/g,
                    "",
                  );
                  setEmail(e.target.value);
                }}
                borderRadius={0}
                mt={"-8%"}
                w={"70%"}
                focusBorderColor="transparent"
                _focusVisible={false}
              />
            </Flex>
            <Flex alignItems={"center"} justifyContent={"center"} pr={5} mt={4}>
              <Text
                w={"50%"}
                color={"#3E3E3E"}
                fontSize={{ md: 16, base: 10 }}
                fontWeight={"normal"}
                className="lato-font"
              >
                Message
                <span style={{ color: "#FC1A64" }}>*</span>{" "}
              </Text>
              <Textarea
                border={0}
                borderBottom={"1px solid gray"}
                type="text"
                name="message"
                value={message}
                onChange={(e) => {
                  const sanitizedValue = e.target.value.replace(
                    /[^a-zA-Z\s]/g,
                    "",
                  );
                  setMessage(sanitizedValue);
                }}
                borderRadius={0}
                mt={"-8%"}
                w={"70%"}
                focusBorderColor="transparent"
                _focusVisible={false}
              />
            </Flex>
            <Button
              bg={"#FC1A64"}
              w={"95%"}
              color={"white"}
              fontWeight={"bold"}
              borderRadius={5}
              m={"auto"}
              mt={"10%"}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CorporateGifting;
